import React, { Component, Fragment } from 'react'
import moment from 'moment-business-days'
import 'moment/locale/nl'
import { Mutation } from 'react-apollo'
import { Link, withRouter } from 'react-router-dom'
import { HOOK_URL } from '../../constants'

import { SUBMIT_ORDER, CREATE_PORTAL_ORDER, SEND_CONTACT, DELETE_PORTAL_ORDER, CREATE_NEW_PORTAL_ORDER } from '../../mutations'
import helpers from '../../helpers'

import { FlexContainer } from '../../styles/defaults'
import {
  ProductContainer,
  OrderContainer,
  Wrapper,
  Title,
  Amount,
  Button,
  StickyOrder,
  StickyAmount,
  StickyButton,
  ProductHeader,
  ProductTitle,
  DesktopWrapper,
  MobileWrapper,
  Content,
  Seperator,
  Notes,
  Price,
  StickyPrice
} from './styles'

import Order from '../Order/'
import SubmitOrderPopup from '../SubmitOrderPopup/'
import EmployeeCTA from '../EmployeeCTA/'

import employee from '../../assets/cta/employee.png'

class Orders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filteredProducts: [],
      popupActive: false,
      query: ''
    }
  }

  calculateOrders() {
    let amount = 0
    Object.keys(this.props.order).map((key, index) => {
      return (amount = amount + this.props.order[key])
    })
    return amount
  }

  calculatePrice() {
    let price = 0
    this.props.wholeOrder.orderParts.map((orderPart) => {
      // Search for priceAgreements with the same product, sort by priority and take the last one
      const priceAgreementsProduct = this.props.priceAgreements ? this.props.priceAgreements.filter(priceAgreement => priceAgreement.productCode === orderPart.product.productCode) : false
      const priceAgreementSorted = priceAgreementsProduct.length > 0 ? priceAgreementsProduct.sort((a, b) => a.priority - b.priority)
      .filter((item, index, array) => item.priority === array[0].priority) : false
      const priceAgreement = priceAgreementSorted.length > 0 ? priceAgreementSorted[0] : false
      let orderPartPrice = priceAgreement ? priceAgreement.percentage ? orderPart.product.price * ((100 - priceAgreement.percentage) / 100) : priceAgreement.price : orderPart.product.price
      orderPartPrice = orderPart.product.category.category === 'SUP' ? 0 : orderPartPrice
      price = price + orderPartPrice * orderPart.amount
      return price
    })
    return price > 0 ? Number(price).toFixed(2).replace('.', ',') : false
  }

  onSearch(e) {
    let query = e.target.value.trim().toLowerCase()
    let queryLength = e.target.value.length
    this.setState({ query: e.target.value })

    const { strippedProducts } = this.props

    const result =
      queryLength === 0
        ? []
        : strippedProducts.filter(
            product =>
              product.firstDescription.toLowerCase().slice(0, queryLength) === query ||
              product.firstDescription.toLowerCase().indexOf(query) !== -1 ||
              product.productCode.toLowerCase().slice(0, queryLength) === query
          )
    if (result.length > 0) {
      this.setState({ filteredProducts: result })
    } else {
      this.setState({ filteredProducts: [] })
    }
  }

  handleClick(e) {
    this.setState({ popupActive: true })
    document.body.classList.add('popup-active')
    document.documentElement.classList.add('popup-active')
  }

  closePopup() {
    this.setState({ popupActive: false })
    document.body.classList.remove('popup-active')
    document.documentElement.classList.remove('popup-active')
  }
  
  render() {
    const order = this.props.wholeOrder
    this.order = order
    const hookUrl = window.sessionStorage.getItem(HOOK_URL)

    let productTypes = {
      coffee: {
        description: 'Koffie',
        products: order.orderParts.filter(orderPart =>
          ['KFB', 'KFBF', 'KFG', 'KFGF', 'KFL', 'KFLF', 'KFV', 'KFVF', 'KFBRA', 'KFGRF', 'KFVRF'].includes(orderPart.product.category.category) && orderPart.amount > 0
        ),
        productsWithoutAmount: order.orderParts.filter(orderPart =>
          ['KFB', 'KFBF', 'KFG', 'KFGF', 'KFL', 'KFLF', 'KFV', 'KFVF', 'KFBRA', 'KFGRF', 'KFVRF'].includes(orderPart.product.category.category) && orderPart.amount < 1
        ).concat(this.props.emptyOrder.orderParts.filter(orderPart => ['KFB', 'KFBF', 'KFG', 'KFGF', 'KFL', 'KFLF', 'KFV', 'KFVF', 'KFBRA', 'KFGRF', 'KFVRF'].includes(orderPart.product.category.category))),
      },
      thee: {
        description: 'Thee',
        products: order.orderParts.filter(orderPart => ['THE', 'THEF', 'THERF'].includes(orderPart.product.category.category) && orderPart.amount > 0),
        productsWithoutAmount: order.orderParts.filter(orderPart => ['THE', 'THEF', 'THERF'].includes(orderPart.product.category.category) && orderPart.amount < 1).concat(this.props.emptyOrder.orderParts.filter(orderPart => ['THE', 'THEF', 'THERF'].includes(orderPart.product.category.category)))
      },
      food: {
        description: 'Food',
        products: order.orderParts.filter(orderPart =>
          ['SOE', 'KOE', 'CAC', 'TOP', 'SUI', 'MLK', 'FRI','OFO'].includes(orderPart.product.category.category) && orderPart.amount > 0
        ),
        productsWithoutAmount: order.orderParts.filter(orderPart =>
          ['SOE', 'KOE', 'CAC', 'TOP', 'SUI', 'MLK', 'FRI', 'OFO'].includes(orderPart.product.category.category) && orderPart.amount < 1
        ).concat(this.props.emptyOrder.orderParts.filter(orderPart => ['SOE', 'KOE', 'CAC', 'TOP', 'SUI', 'MLK', 'FRI'].includes(orderPart.product.category.category)))
      },
      nonFood: {
        description: 'Non-food',
        products: order.orderParts.filter(orderPart =>
          ['BEK', 'BEP', 'ROE', 'HYG', 'SMK', 'REI', 'SER', 'ONF', 'FIL'].includes(orderPart.product.category.category) && orderPart.amount > 0
        ),
        productsWithoutAmount: order.orderParts.filter(orderPart =>
          ['BEK', 'BEP', 'ROE', 'HYG', 'SMK', 'REI', 'SER', 'ONF', 'FIL'].includes(orderPart.product.category.category) && orderPart.amount < 1
        ).concat(this.props.emptyOrder.orderParts.filter(orderPart => ['BEK', 'BEP', 'ROE', 'HYG', 'SMK', 'REI', 'SER', 'ONF', 'FIL'].includes(orderPart.product.category.category)))
      },
      notes: {
        description: 'Notities',
        products: order.orderParts.filter(orderPart =>
          ['TXT'].includes(orderPart.product.category.category)
        ),
        productsWithoutAmount: []
      }
    }

    let employeeContent = {
      title: 'Vragen?',
      subtitle: 'We helpen u graag',
      employee: true,
      image: employee,
      link: {
        content: 'Contact',
        url: '/contact',
        target: ''
      }
    }
    let showSeperator = false
    Object.keys(productTypes).map((type) => {
      if (productTypes[type].productsWithoutAmount.length > 0 && this.calculateOrders() > 0) {
        showSeperator = true
      }
      return ''
    })

    return (
      <FlexContainer full mb>
        <ProductContainer>
          {Object.keys(productTypes).map((type, index) => {
            if (productTypes[type].products.length > 0) {
              if (type === 'notes') {
                return (
                  <Fragment key={index}>
                    <ProductHeader>
                      <ProductTitle>{productTypes[type].description}</ProductTitle>
                    </ProductHeader>
                    <Notes>
                      <ul>
                        {productTypes[type].products.map((note, index) => {
                          return <li key={index}>{note.note}</li>
                        })}
                      </ul>
                    </Notes>
                  </Fragment>
                )
              }
              return (
                <Fragment key={index}>
                  <ProductHeader>
                    <ProductTitle>{productTypes[type].description}</ProductTitle>
                    <Link to={`/assortiment/${productTypes[type].description.toLowerCase()}`}>Bekijk assortiment</Link>
                  </ProductHeader>
                  {productTypes[type].products.map((orderPart, index) => {
                    return (
                      <Order
                        key={orderPart.product.id + '-' + index}
                        product={orderPart.product}
                        wholeOrder={this.props.wholeOrder}
                        orderParts={this.props.order}
                        priceAgreements={this.props.priceAgreements}
                        viewPrices={this.props.viewPrices}
                        orderId={this.props.orderId}
                        order={this.props.order[`${orderPart.id}`]}
                        editOrder={this.props.editOrder}
                        servicePackage={this.props.servicePackage}
                        noAmount={false}
                        branchData={this.props.branchData}
                      />
                    )
                  })}
                </Fragment>
              )
            } else {
              return null
            }
          })}
          {showSeperator ? <Seperator>Ook in uw assortiment:</Seperator> : null}
          {Object.keys(productTypes).map((type, index) => {
            if (productTypes[type].productsWithoutAmount.length > 0) {
              return (
                <Fragment key={index}>
                  <ProductHeader>
                    <ProductTitle>{productTypes[type].description}</ProductTitle>
                    <Link to={`/assortiment/${productTypes[type].description.toLowerCase()}`}>Bekijk assortiment</Link>
                  </ProductHeader>
                  {productTypes[type].productsWithoutAmount.map((orderPart, index) => {
                  return (
                    <Order
                      key={orderPart.product.id + '-' + index}
                      product={orderPart.product}
                      wholeOrder={this.props.wholeOrder}
                      orderParts={this.props.order}
                      priceAgreements={this.props.priceAgreements}
                      viewPrices={this.props.viewPrices}
                      orderId={this.props.orderId}
                      order={this.props.order[`${orderPart.id}`]}
                      editOrder={this.props.editOrder}
                      servicePackage={this.props.servicePackage}
                      branchData={this.props.branchData}
                      noAmount={true}
                    />
                  )
                })}
                </Fragment>
              )
            } else {
              return null
            }
          })}


        </ProductContainer>

        <OrderContainer>
          <Wrapper secondChild>
            <Title>Bestellijst</Title>
            <Amount>
              Producten
              <strong>{this.calculateOrders()} st.</strong>
            </Amount>
            {(this.props.viewPrices && this.calculatePrice() && hookUrl) || (this.props.viewPrices && this.calculatePrice() && this.props.branchData.minimalOrderValueActive && this.props.branchData.minimalOrderValue) ? (
              <Price>
                Totaal
                <strong>€ {this.calculatePrice()}</strong>
              </Price>
            ) : null}
            {(this.props.viewPrices && this.calculatePrice() && this.props.branchData.minimalOrderValueActive && this.props.branchData.minimalOrderValue) ? (
              <Price>
                Minimale orderwaarde
                <strong>€ {this.props.branchData.minimalOrderValue.toFixed(2).replace('.', ',')}</strong>
              </Price>
            ) : null}
            {this.props.wholeOrder.deliveryNumber ? (
              <Content>
                <h4>Ordernummer</h4>
                <p>#{this.props.wholeOrder.deliveryNumber}</p>
              </Content>
            ) : null}
            <Content>
              <h4>Servicepakket</h4>
              <p>U heeft het servicepakket <Link to="/servicepakketten">{this.props.servicePackage}</Link>.</p>
            </Content>
            {!this.props.portalOrderId && this.props.servicePackage === 'Ondersteun' ? (
              <Fragment>
                <Content>
                  <h4>Producten nodig?</h4>
                  <p>Heeft u eerder dan de volgende besteldatum producten nodig? Druk op de onderstaande knop en wij nemen zo spoedig mogelijk contact met u op.</p>
                </Content>
                <Mutation mutation={SEND_CONTACT}>
                  {(sendContactForm, { data, loading, error }) => {
                    if (loading) {
                      return  <Content><p>Bericht verzenden...</p></Content>
                    }
                    if (data) {
                      return <Content><p>Uw bericht is verzonden. We nemen zo snel mogelijk contact met u op.</p></Content>
                    }
                    return (
                      <Button onClick={(e) => {
                        const { user } = this.props
                        user.insertion = helpers.findInsertion(user.insertion)
                        sendContactForm({
                          variables: {
                            data: {
                              to: process.env.REACT_APP_HOST_ENV === 'production' ? 'bestellen@kaarskoffie.nl' : 'teun@bureaubright.nl',
                              user: user.firstName + ' ' + (user.insertion ? user.insertion : '') + ' ' + user.lastName,
                              userId: user.id,
                              branch: this.props.branchName,
                              branchId: this.props.branch,
                              message: 'Deze klant heeft om spoedcontact gevraagd i.v.m. een extra bestelling. Neem zo snel mogelijk contact op met deze klant.'
                            }
                          }
                        })
                      }}>Bestelling aanvragen</Button>
                    )
                  }}
                </Mutation>
              </Fragment>
            ) : (
              <Fragment>
              <Content>
                <h4>Behoefte aan andere producten?</h4>
                <p>Heeft u behoefte aan extra producten in uw assortiment? Neem dan <Link to="/contact">contact</Link> met ons op.</p>
              </Content>
              </Fragment>
            )} 
            {this.calculateOrders() > 0 ? (
              <Fragment>
                {this.props.sendOrder ? (
                  <Fragment>
                    <Link to="/bestelling-plaatsen"><Button>Bevestigen</Button></Link>
                  </Fragment>
                ) : null}
              </Fragment>
              ) : <Fragment>
                
                </Fragment>}
              <Fragment>
              {!this.props.wholeOrder.submitted && (this.props.wholeOrder.code !== '25' && this.props.wholeOrder.code !== '27' && this.props.wholeOrder.code !== '30' && this.props.wholeOrder.code !== '35' && this.props.wholeOrder.code !== '40') && this.props.portalOrderId && this.props.servicePackage === 'Flexibel' && this.props.sendOrder ? (
                  <Mutation 
                    mutation={DELETE_PORTAL_ORDER}
                  >
                  {(deletePortalOrder, { data, loading, error }) => {
                    if (data) {
                      window.location.href = '/bestellijst'
                    }
                    return <Button onClick={(e) => { deletePortalOrder({ variables: { data: { id: this.props.portalOrderId } } })}}>Bestelling annuleren</Button>
                  }}
                </Mutation>
                ) : null}
                {this.props.wholeOrder.ociPlatform && (this.props.wholeOrder.ociPlatform === 'AFAS' || this.props.wholeOrder.ociPlatform === 'Axxerion' || this.props.wholeOrder.ociPlatform === 'ProActive') && (this.props.wholeOrder.code !== '25' && this.props.wholeOrder.code !== '27' && this.props.wholeOrder.code !== '30' && this.props.wholeOrder.code !== '35' && this.props.wholeOrder.code !== '40') && this.props.portalOrderId && this.props.deleteOciOrder ? (
                  <Mutation 
                    mutation={DELETE_PORTAL_ORDER}
                  >
                  {(deletePortalOrder, { data, loading, error }) => {
                    if (data) {
                      window.location.href = '/bestellijst'
                    }
                    return <Button onClick={(e) => { deletePortalOrder({ variables: { data: { id: this.props.portalOrderId } } })}}>Bestelling annuleren</Button>
                  }}
                </Mutation>
              ) : null}
              </Fragment>
              {this.props.createOrder ? (
              <Mutation 
                mutation={CREATE_PORTAL_ORDER}
              >
                {(createPortalOrder, { data, loading, error }) => {
                  if (data) {
                    window.location.href = '/bestellijst'
                  }
                  return <Button onClick={(e) => { createPortalOrder({ variables: { data: { branch: this.props.branch, order: this.props.orderId } } })}}>Nieuwe bestelling invullen</Button>
                }}
              </Mutation>
            ) : null}
            {this.props.createNewOrder ? (
              <Mutation 
                mutation={CREATE_NEW_PORTAL_ORDER}
              >
                {(createNewPortalOrder, { data, loading, error }) => {
                  if (data) {
                    window.location.href = '/bestellijst'
                  }
                  return (
                    <Fragment>
                      <Content>
                        <h4>Alvast een nieuwe bestelling plaatsen?</h4>
                        <p>U heeft al een bestelling staan, deze komen we {moment(this.props.wholeOrder.deliveryDate).format('dddd D MMMM')} leveren. U kunt d.m.v. de onderstaande knop alvast een nieuwe bestelling invullen.</p>
                      </Content>
                      <Button onClick={(e) => { createNewPortalOrder({ variables: { data: { branch: this.props.branch, order: this.props.oldOrderId } } })}}>Nieuwe bestelling invullen</Button>
                    </Fragment>
                  )
                }}
              </Mutation>
            ) : null}
              
            

            
          </Wrapper>
          <DesktopWrapper>
            <EmployeeCTA size={'small'} mt content={employeeContent} />
          </DesktopWrapper>
        </OrderContainer>

        {this.state.popupActive ? (
          <Mutation mutation={SUBMIT_ORDER}>
            {(submitOrder, { data, loading, error }) => {
              if (data) {
                document.body.classList.remove('popup-active')
                document.documentElement.classList.remove('popup-active')
                // this.props.history.push('/bestellijst/bedankt')
                window.location.href = '/bestellijst/bedankt'
              }

              return (
                <SubmitOrderPopup
                  closePopup={this.closePopup.bind(this)}
                  id={this.props.orderId}
                  submitOrder={submitOrder}
                  reference={this.props.wholeOrder.clientReference ? this.props.wholeOrder.clientReference : ''}
                  title={'Weet u zeker dat u deze bestelling wilt versturen?'}
                  placeholder={'Geef hier uw referentie op'}
                  confirm={'Ja, verzend deze bestelling'}
                  deny={'Annuleren'}
                  user={this.props.user}
                />
              )
            }}
          </Mutation>
        ) : null}

        {!this.props.portalOrderId && this.props.servicePackage === 'Ondersteun' ? (
          <Content mobile>
            <h4>Producten nodig?</h4>
            <p>Heeft u eerder dan de volgende besteldatum producten nodig? Druk op de onderstaande knop en wij nemen zo spoedig mogelijk contact met u op.</p>
          </Content>
        ) : (
          <Content mobile>
            <h4>Behoefte aan andere producten?</h4>
            <p>Heeft u behoefte aan extra producten in uw assortiment? Neem dan <Link to="/contact">contact</Link> met ons op.</p>
          </Content>
        )}
 
        <StickyOrder>
          <StickyAmount>
            Producten
            <strong>{this.calculateOrders()} st.</strong>
          </StickyAmount>
          {(this.props.viewPrices && this.calculatePrice() && hookUrl) || (this.props.viewPrices && this.calculatePrice() && this.props.branchData.minimalOrderValueActive && this.props.branchData.minimalOrderValue) ? (
            <StickyPrice>
              Totaal
              <strong>€ {this.calculatePrice()}</strong>
            </StickyPrice>
          ) : null}
          {(this.props.viewPrices && this.calculatePrice() && this.props.branchData.minimalOrderValueActive && this.props.branchData.minimalOrderValue) ? (
            <StickyPrice>
              Minimale orderwaarde
              <strong>€ {this.props.branchData.minimalOrderValue.toFixed(2).replace('.', ',')}</strong>
            </StickyPrice>
          ) : null}
          {!this.props.portalOrderId && this.props.servicePackage === 'Ondersteun' ? (
          <Fragment>
            <Mutation mutation={SEND_CONTACT}>
              {(sendContactForm, { data, loading, error }) => {
                if (loading) {
                  return  <Content mobile><p>Bericht verzenden...</p></Content>
                }
                if (data) {
                  return <Content mobile><p>Uw bericht is verzonden. We nemen zo snel mogelijk contact met u op.</p></Content>
                }
                return (
                  <StickyButton onClick={(e) => {
                    const { user } = this.props
                    sendContactForm({
                      variables: {
                        data: {
                          to: process.env.REACT_APP_HOST_ENV === 'production' ? 'bestellen@kaarskoffie.nl' : 'teun@bureaubright.nl',
                          user: user.firstName + ' ' + (user.insertion ? user.insertion : '') + ' ' + user.lastName,
                          userId: user.id,
                          branch: this.props.branchName,
                          branchId: this.props.branch,
                          message: 'Deze klant heeft om spoedcontact gevraagd i.v.m. een extra bestelling. Neem zo snel mogelijk contact op met deze klant.'
                        }
                      }
                    })
                  }}>Contact</StickyButton>
                )
              }}
            </Mutation>
          </Fragment>
        ) : null} 
          {this.calculateOrders() > 0 ? (
            <Fragment>
              {this.props.sendOrder ? (
                <Fragment>
                  <Link to="/bestelling-plaatsen"><StickyButton>Bevestigen</StickyButton></Link>
                </Fragment>
              ) : null}
            </Fragment>
          ) : (
            null
          )}
          <Fragment>
          {!this.props.wholeOrder.submitted && (this.props.wholeOrder.code !== '25' && this.props.wholeOrder.code !== '27' && this.props.wholeOrder.code !== '30' && this.props.wholeOrder.code !== '35' && this.props.wholeOrder.code !== '40') && this.props.portalOrderId && this.props.servicePackage === 'Flexibel' && this.props.sendOrder ? (
              <Mutation 
                mutation={DELETE_PORTAL_ORDER}
              >
              {(deletePortalOrder, { data, loading, error }) => {
                if (data) {
                  window.location.href = '/bestellijst'
                }
                return <StickyButton onClick={(e) => { deletePortalOrder({ variables: { data: { id: this.props.portalOrderId } } })}}>Bestelling annuleren</StickyButton>
              }}
            </Mutation>
          ) : null}
          {!this.props.ociPlatform && (this.props.ociPlatform === 'AFAS' || this.props.ociPlatform === 'Axxerion' || this.props.ociPlatform === 'ProActive')  && (this.props.wholeOrder.code !== '25' && this.props.wholeOrder.code !== '27' && this.props.wholeOrder.code !== '30' && this.props.wholeOrder.code !== '35' && this.props.wholeOrder.code !== '40') && this.props.portalOrderId && this.props.servicePackage === 'Flexibel' && this.props.sendOrder ? (
              <Mutation 
                mutation={DELETE_PORTAL_ORDER}
              >
              {(deletePortalOrder, { data, loading, error }) => {
                if (data) {
                  window.location.href = '/bestellijst'
                }
                return <StickyButton onClick={(e) => { deletePortalOrder({ variables: { data: { id: this.props.portalOrderId } } })}}>Bestelling annuleren</StickyButton>
              }}
            </Mutation>
          ) : null}
          </Fragment>
          {this.props.createOrder ? (
            <Mutation 
              mutation={CREATE_PORTAL_ORDER}
            >
              {(createPortalOrder, { data, loading, error }) => {
                if (data) {
                  window.location.href = '/bestellijst'
                }
                return <StickyButton onClick={(e) => {createPortalOrder({ variables: { data: { branch: this.props.branch, order: this.props.orderId } } })}}>Nieuwe bestelling invullen</StickyButton>
              }}
            </Mutation>
          ) : null}
          
        </StickyOrder>
        <MobileWrapper>
          <EmployeeCTA size={'small'} mt content={employeeContent} />
        </MobileWrapper>
      </FlexContainer>
    )
  }
}

export default withRouter(Orders)



// WEBPACK FOOTER //
// ./src/components/Orders/index.js